const $htmlBody = $('html, body');
const $head = $('.head');
const $nav = $('.nav');

NLMK.scrollTopConsideringHeadFixing = scrollTopConsideringHeadFixing;

NLMK.scrollTo = scrollTo;

function scrollTo($element) {
    if ($element && $element.length) {
        const navHeight = window.matchMedia('(min-width: 1024px)').matches ? $nav.height() : 0;
        $htmlBody.animate({ scrollTop: $element.offset().top - navHeight }, NLMK.TRANSITION_DURATION);
    }
}

function scrollTopConsideringHeadFixing(top) {
    $htmlBody.animate({ scrollTop: top - getScrollTopShift() }, NLMK.TRANSITION_DURATION);
}

function getScrollTopShift() {
    const isHeadFixed = $head.hasClass('fixed');

    return isHeadFixed ? $head.height() : 0;
}



// WEBPACK FOOTER //
// ./js/main/module/scroll-top.js